import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import type { JobChangeProcess, JobChangeProcessDetail } from '../types/JobChangeProcess';
import type { QueryObserverResult, RefetchOptions } from '@tanstack/react-query';

type JobChangeProcessQuery = {
  stepRange?: string[];
  dateRange?: {
    start: string;
    end: string;
  };
  order?: string;
  scheduleStatuses?: string[];
  result?: string | string[];
};

const today = new Date();
const past5Years = new Date();
past5Years.setFullYear(today.getFullYear() - 5);
const from5years = new Date();
from5years.setFullYear(today.getFullYear() + 5);

const formatDate = (date: Date): string => {
  return date.toISOString().split('T')[0];
};

export const IN_PROGRESS_RESULTS = ['processing', 'offered'];

export const jobChangeProcessQueryAtom = atom<JobChangeProcessQuery>({
  stepRange: undefined,
  dateRange: { start: formatDate(past5Years), end: formatDate(from5years) },
  order: '-updated_at',
  scheduleStatuses: undefined,
  result: IN_PROGRESS_RESULTS,
});

export const currentSelectjobChangeProcessAtom = atom<JobChangeProcess | null>(null);

export const jobChangeProcessScreenType = atomWithStorage<'list' | 'board'>(
  'jobChangeProcessScreenType',
  'list'
);

type SharedSearch = {
  keyword: string;
  organizationUserIds: number[];
};

export const jobChangeProcessSearchAtom = atomWithStorage<SharedSearch>(
  'jobChangeProcessSearch',
  { keyword: '', organizationUserIds: [] },
  undefined,
  { getOnInit: true }
);

export const openedStatusMenuIdAtom = atom<number | null>(null);

export const currentjobChangeProcessStatusAtom = atom<
  'offer' | 'close' | 'decline' | 'reject' | 'progress' | null
>(null);

export const currentSelectjobChangeProcessLogStatusAtom = atom<{
  result: string;
  interviewedAt: string | null;
  jobChangeProcessId: number;
  latestLogId: number;
  type: 'edit' | 'delete';
  refetch: (
    options?: RefetchOptions
  ) => Promise<QueryObserverResult<JobChangeProcessDetail, Error>>;
} | null>(null);
